import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Month } from './month.model';

@Component({
  selector: 'app-month-filter',
  templateUrl: './month-filter.component.html',
  styleUrls: ['./month-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonthFilterComponent implements OnInit, OnChanges {
  @Input() selectedMonth?: Month;
  @Output() changeMonth = new EventEmitter();

  months: Month[] = [
    { abrev: 'JAN', num: 0, selected: false },
    { abrev: 'FEV', num: 1, selected: false },
    { abrev: 'MAR', num: 2, selected: false },
    { abrev: 'ABR', num: 3, selected: false },
    { abrev: 'MAI', num: 4, selected: false },
    { abrev: 'JUN', num: 5, selected: false },
    { abrev: 'JUL', num: 6, selected: false },
    { abrev: 'AGO', num: 7, selected: false },
    { abrev: 'SET', num: 8, selected: false },
    { abrev: 'OUT', num: 9, selected: false },
    { abrev: 'NOV', num: 10, selected: false },
    { abrev: 'DEZ', num: 11, selected: false },
  ];
  constructor() {}

  ngOnInit(): void {
    if (!this.selectedMonth) {
      const month = this.getCurrentMonth();
      if (month) this.select(month);
    }
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.selectedMonth) {
      const selected: Month = changes.selectedMonth.currentValue;

      if (!selected) {
          const currentMonth = this.getCurrentMonth();
          if (currentMonth) {
              this.select(currentMonth);
          }
          return;
      }
      const monthToSelect = this.months.find(m => m.num === selected.num);
      if (monthToSelect) {
        this.select(monthToSelect);
      }
    }
  }

  select(month: Month): void {
    this.months.forEach((m) => (m.selected = false));
    month.selected = true;
    this.changeMonth.emit(month);
  }

  private getCurrentMonth() {
    return this.months.find((m) => m.num === new Date().getMonth());
  }
}
